module.exports = __webpack_public_path__ + "0f93cd703e9e45a0ac060cf227227dc5.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/charts/c_line_stacked_bar_1day_show_labels.png
// module id = 875
// module chunks = 7